// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1lcBREBS_K3H","title":"qH39Ghof-w1k","text":"m4keOybKFF-_","footer":"_25v15Y-yfIru","button":"ZNM5xN1KxQQ2"};